const STATUSES = {
  DRAFT: { id: 1, name: 'draft' },
  SENT: { id: 2, name: 'sent' },
};

export default STATUSES;
